import { Grid, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';

/* Este componente corresponde a los headers que usualmente son usados en las
páginas de Wholemeaning. Cada una de las vistas extiende de éste, agregando sus propios
elementos dentro. Recibe elementos children. */

const CustomHeaderStyle = makeStyles({
  shadowWhenScroll: {
    paddingBottom: 1,
  },
  headerDimensions: {
    width: '100%',
  },
});

interface ICustomHeader {
  readonly headerHeight?: number;
  readonly children: JSX.Element;
}

const CustomHeader = ({ children, headerHeight = 50 }: ICustomHeader) => {
  const classes = CustomHeaderStyle();

  return (
    <Grid container={true} alignItems="center" className={classes.shadowWhenScroll}>
      <Grid item={true} xs={12}>
        <Paper className={classes.headerDimensions} style={{ height: headerHeight }} elevation={2}>
          {children}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default CustomHeader;
